import type {Space} from "#material/nodes/vector/displacement/validation"

export const cyclesSpace = (space?: Space) => {
    if (!space) {
        return undefined
    }
    switch (space) {
        case "OBJECT":
            return "object"
        case "WORLD":
            return "world"
    }
}
